import { AntDatePicker, defaultTheme } from '@agro-club/agroclub-shared'
import useLanguage from 'hooks/useLanguage'
import { ComponentProps, FC } from 'react'
import { useMediaQuery } from 'react-responsive'

interface Props extends Omit<ComponentProps<typeof AntDatePicker>, 'onChange' | 'locale'> {
  onChange: (customDate: object) => void
}

export const DatePicker: FC<Props> = (props) => {
  const locale = useLanguage()

  const isMobile = useMediaQuery({
    query: `(max-width: ${defaultTheme.queries.mobile})`,
  })

  return (
    <AntDatePicker
      locale={locale}
      size={isMobile ? 'large' : 'middle'}
      fullWidth={props.fullWidth || isMobile}
      {...props}
    />
  )
}
